import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { shellConnectorToken } from '../../../team-apis/core/shell-connector';
import { AbstractSensorContentStore } from '../../state/abstract-sensor-content-store';

@Component({
  selector: 'h3-layer-view-settings-popover',
  templateUrl: './layer-view-settings-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LayerViewSettingsPopoverComponent extends DirectiveSuperclass {
  persistLayerSettingsStore = inject(
    AbstractSensorContentStore,
  ).getLayerSettingsStore()('persist');

  private shellConnector = inject(shellConnectorToken);

  trackPersistenceChange() {
    this.shellConnector.trackEvent({
      id: 'toggle_persist_shape_settings',
      bucket: 'navigation',
      sub_bucket: 'frame',
      new_value: this.persistLayerSettingsStore.state(),
    });
  }
}
